import MenuBar from "../Component/MenuBar";
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
import { Carousel } from "react-bootstrap";

const Anniversary = () => {
    return (

        <>

            <MenuBar />
            <Sidebar />
            {/* <!-- Page Banner Section --> */}
            <PageBanner title="Yugal Kunj 10th Anniversary - Retreat Schedule" />

            {/* <!--End Banner Section --> */}

            <div className="container">



                <div className="auto-container">

                    <div className="centered">
                        <hr />
                        <h3 style={{ marginBottom: "20px" }}> Yugal Kunj 10th Anniversary - Retreat Schedule </h3>

                        <a href="https://anniversary.yugalkunj.org/annreg/" target="_blank" className="alert alert-primary" style={{ marginBottom: "20px" }}>
                            <span className="btn-title"><span className="fa fa-2x fa fa-hand-o-right"></span>  Please click here for registration </span>
                        </a>

                    </div>
                </div>




                <div className="row" style={{ marginTop: "20px" }}>




                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">  Yugal Kunj 10th Anniversary - Retreat </h5>

                            </div>
                            <div className="card-body pt-0">
                                <div className="widget-49">


                                    <figure className="image">
                                        <img src="https://yugalkunj.org/images/annregmain.jpg" alt="" style={{ width: "100%" }} />
                                        <a href="https://yugalkunj.org/images/annregmain.jpg" className="lightbox-image overlay" data-fancybox="gallery-two"></a>
                                    </figure>
                                    <br />
                                    <div className="widget-49-meeting-action">
                                        <a href="https://yugalkunj.org/images/annregmain.jpg" target="_blank" className="btn btn-sm btn-flash-border-primary">View Flyer</a>
                                    </div>



                                    <hr />

                                    <div>






                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>




                </div>







                <hr />
                <section className="coming-events">

                    <div className="auto-container">
                        <div className="sec-title centered">

                            <h2> Yugal Kunj 10th Anniversary - Retreat Schedule </h2>



                        </div>



                        <Carousel variant="dark">

                            <Carousel.Item >
                                <img
                                    className="d-block w-100"
                                    src="https://yugalkunj.org/images/Retreat-schedule-.jpg"
                                    alt="Second slide"
                                />

                            </Carousel.Item>

                            {/* <Carousel.Item >
                <img
                  className="d-block w-100"
                  src="https://yugalkunj.org/images/week2.jpg"
                  alt="Second slide"
                />

              </Carousel.Item> */}

                            {/* 
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://yugalkunj.org/images/week3.jpg"
                  alt="Third slide"
                />


              </Carousel.Item>

              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://yugalkunj.org/images/week4.jpg"
                  alt="Third slide"
                />


              </Carousel.Item>


              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://yugalkunj.org/images/week5.jpg"
                  alt="Third slide"
                />


              </Carousel.Item>

              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://yugalkunj.org/images/week6.jpg"
                  alt="Third slide"
                />


              </Carousel.Item> */}



                        </Carousel>



                    </div>
                </section>
















            </div>















































            <Footer />
        </>
    )

}
export default Anniversary;
